/** See `src/i18n/locales/en/statistics.ts`. */
export const statistics = {
  panelType: {
    series: 'Reihe',
    sessions: 'Sitzungen',
    availability: 'Verfügbarkeit',
  },
  status: {
    forbidden: 'Du darfst das nicht sehen.',
    insufficientData:
      'Noch nicht genug Personen haben Daten, um diese Gruppe zu zeigen, ohne jemanden zu identifizieren.',
    noMetrics: 'Keine Messwerte in diesem Zeitraum.',
    noData: 'Keine Daten in diesem Zeitraum.',
    noSessions: 'Keine Sitzungen in diesem Zeitraum.',
    noAvailability: 'Keine Daten erfasst.',
    loadFailed: 'Dieses Panel konnte nicht geladen werden: {{message}}',
  },
  target: {
    you: 'Du',
    department: 'Abteilung {{name}}',
    company: 'Unternehmen {{name}}',
  },
  table: {
    date: 'Datum',
    type: 'Typ',
    duration: 'Dauer',
    calories: 'Kalorien',
    avgHeartRate: 'Ø Herzfrequenz',
    minutes: '{{count}} Min.',
    metric: 'Messwert',
    source: 'Quelle',
    first: 'Erste',
    last: 'Letzte',
    days: 'Tage',
  },
  detailLink: 'Details ansehen',
  range: {
    last7Days: 'Letzte 7 Tage',
    last30Days: 'Letzte 30 Tage',
    last90Days: 'Letzte 90 Tage',
    thisWeek: 'Diese Woche',
    thisMonth: 'Diesen Monat',
    custom: 'Benutzerdefiniert…',
    from: 'Von',
    to: 'Bis',
  },
} as const;
